const LISTING_TYPE_ROUTES = {
    vacancy: '/vacancy',
    resume: '/resume',
    offering: '/offering',
    product: '/product',
    realty: '/realty',
};

export function resolveNotificationTarget(notification) {
    const p = notification?.payload;
    if (!p) return null;

    if (p.chat_id) return { name: 'ChatDetailPage', params: { id: p.chat_id } };
    if (p.quick_post_id) return `/quick-posts/${p.quick_post_id}`;
    if (p.listing_id) {
        const base = p.listing_type ? (LISTING_TYPE_ROUTES[p.listing_type] ?? null) : null;
        if (base) return `${base}/${p.listing_id}`;
    }
    if (p.news_id) return `/news/${p.news_id}`;
    if (p.group_id) return `/groups/${p.group_id}`;
    return null;
}

export const TARGET_LABELS = {
    chat:       'Нажмите, чтобы перейти в чат',
    vacancy:    'Нажмите, чтобы перейти к вакансии',
    resume:     'Нажмите, чтобы перейти к резюме',
    offering:   'Нажмите, чтобы перейти к услуге',
    product:    'Нажмите, чтобы перейти к товару',
    realty:     'Нажмите, чтобы перейти к объявлению',
    news:       'Нажмите, чтобы перейти к новости',
    group:      'Нажмите, чтобы перейти к группе',
    quick_post: 'Нажмите, чтобы перейти к объявлению',
};

export function resolveTargetLabel(notification) {
    const p = notification?.payload;
    if (!p) return 'Нажмите, чтобы перейти';
    if (p.chat_id) return TARGET_LABELS.chat;
    if (p.quick_post_id) return TARGET_LABELS.quick_post;
    if (p.listing_type && TARGET_LABELS[p.listing_type]) return TARGET_LABELS[p.listing_type];
    if (p.news_id) return TARGET_LABELS.news;
    if (p.group_id) return TARGET_LABELS.group;
    return 'Нажмите, чтобы перейти';
}

const KIND_CONFIG = {
    comment:     {emoji: '💬', bg: 'bg-blue-100 dark:bg-blue-900',   text: 'text-blue-600 dark:text-blue-300',   bar: 'bg-blue-500'},
    performer:   {emoji: '🤝', bg: 'bg-green-100 dark:bg-green-900', text: 'text-green-600 dark:text-green-300', bar: 'bg-green-500'},
    new_listing: {emoji: '📦', bg: 'bg-yellow-100 dark:bg-yellow-900', text: 'text-yellow-600 dark:text-yellow-300', bar: 'bg-yellow-500'},
    quick_post:  {emoji: '⚡', bg: 'bg-orange-100 dark:bg-orange-900', text: 'text-orange-600 dark:text-orange-300', bar: 'bg-orange-500'},
    news:        {emoji: '📰', bg: 'bg-purple-100 dark:bg-purple-900', text: 'text-purple-600 dark:text-purple-300', bar: 'bg-purple-500'},
    group:       {emoji: '👥', bg: 'bg-pink-100 dark:bg-pink-900',   text: 'text-pink-600 dark:text-pink-300',   bar: 'bg-pink-500'},
    generic:     {emoji: '🔔', bg: 'bg-gray-100 dark:bg-gray-700',   text: 'text-gray-600 dark:text-gray-300',   bar: 'bg-gray-400'},
};

export function getKindConfig(kind) {
    return KIND_CONFIG[kind] ?? KIND_CONFIG.generic;
}

export function formatRelativeTime(dateString) {
    if (!dateString) return '';
    const now = new Date();
    const date = new Date(dateString);
    const diffMs = now - date;
    const diffMin = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMin < 1) return 'только что';
    if (diffMin < 60) return `${diffMin} мин`;
    if (diffHours < 24) return `${diffHours} ч`;
    if (diffDays === 1) return 'вчера';
    if (diffDays < 7) return `${diffDays} дн`;
    return date.toLocaleDateString('ru-RU', {day: '2-digit', month: '2-digit'});
}

export function formatFullDate(dateString) {
    if (!dateString) return '';
    return new Date(dateString).toLocaleString('ru-RU', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit',
    });
}

export function groupByDate(notifications) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const weekAgo = new Date(today);
    weekAgo.setDate(weekAgo.getDate() - 7);

    const groups = [];
    const map = new Map();

    for (const n of notifications) {
        const d = new Date(n.created_at);
        d.setHours(0, 0, 0, 0);

        let label;
        if (d >= today) label = 'Сегодня';
        else if (d >= yesterday) label = 'Вчера';
        else if (d >= weekAgo) label = 'На этой неделе';
        else label = 'Ранее';

        if (!map.has(label)) {
            const group = {label, items: []};
            map.set(label, group);
            groups.push(group);
        }
        map.get(label).items.push(n);
    }
    return groups;
}
